import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <>
        <div className='f'>
            <div>
            <nav className="menu-bar2">
            <div className="menu-list2">
                <h2><span style={{fontWeight:'900',color:'rgb(150, 137, 137)', fontSize:"55px"}}>𝐼𝒥</span><span style={{color:"rgb(45, 76, 78)"}}> 𝒮𝒜𝒯𝐻𝐼</span></h2>
            </div>
            <div className="menu-list2">
            <a style={{textDecoration:"none"}} target="_blank" rel="noreferrer" href="https://github.com/ijsathi"> <h2><span style={{fontWeight:'600',color:'rgb(45, 76, 78)', fontSize:"40px"}}>𝑀𝒴 </span><span style={{color:"rgb(45, 76, 78)"}}> 𝒢𝐼𝒯𝐻𝒰𝐵</span></h2></a>
               
            </div>
            <div className="resume2">
            <a target="_blank" rel="noreferrer" className="log-in2" href="https://drive.google.com/file/d/1zn-w0QiKUCC_sWQL8tsNR3XIefa1ezQ1/view">MY RESUME</a>
            </div>
        </nav>
            </div>
            <div style={{paddingTop:"64px", textAlign:"center"}}>
                <hr />
                <p><small>Copyright By@<span style={{color:'rgb(1, 78, 83)'}}>I</span>srat Zahan Sathi - 2021</small></p>
            </div>
        </div>

        </>
    );
};

export default Footer;